import React from "react";

import { useParams } from "react-router-dom";

import { ModifierSets } from "features/ModifierSets";
import { PageTitle } from "shared/ui";

// Один экран на оба роута: /menus/modifiers/list и старый /menus/modifiers/:modifierId/view,
// который теперь просто открывает диалог нужного набора (ссылки на него ещё живут в кабинете).
const ModifierSetsPage = () => {
    const { modifierId } = useParams<{ modifierId?: string }>();

    const initialModifierSetId = modifierId ? parseInt(modifierId, 10) : undefined;

    return (
        <>
            <PageTitle>Наборы модификаторов</PageTitle>
            <ModifierSets initialModifierSetId={initialModifierSetId} />
        </>
    );
};

export default ModifierSetsPage;
